import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";

import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { change, Field, formValueSelector, reduxForm } from "redux-form";
import { handleApiErrors } from "../../lib/api-errors";
import { makeGetDataAccount } from "../../lib/selector";
import {
  required,
  validateEmail,
  validatePhone,
  minLength,
} from "../../util/validation";

import * as _ from "lodash";
import RenderDatePicker from "../../components/input/renderDatePicker";
// import RenderFieldBirthday from "../../components/input/renderFieldBirthday";
import InputPhoneNumber from "../../components/input/inputPhoneNumber";
import RenderNormalSelect from "../../components/input/renderNormalSelect";
import RenderFieldNormalInput from "../../components/input/renderFieldInput";
import RenderFieldArea from "../../components/input/renderArea";

import { isDate, replaceAll, validateCMT9, _diff2Date } from "../../util";
import { setDataAccount } from "../client/actions";

const maxLength15 = minLength(15);

const apiUrl = `${process.env.REACT_APP_API_URL}`;

// Hook
function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

function PageAccountDetailPersonal(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [provinceList, setProvinceList] = useState([]);
  const { dataAccount, ocrData, handleSubmit, _handleToast, inputIDPresenter } =
    props;

  const preInputIDPresenter = usePrevious(inputIDPresenter);

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
    // lấy danh sách tỉnh thành
    getProvinceList();

    if (dataAccount?.C_PARAM_PERSONAL) {
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputFname",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_FULL_NAME
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputNgaySinh",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_BIRTHDAY
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputCCCD",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_CARD_ID
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputNgayCap",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_ISSUE_DATE
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputNoiCap",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_ISSUE_PLACE
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputGioiTinh",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_GENDER === "M" ? "NAM" : "NỮ"
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputDienThoai",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_MOBILE
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputEmail",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_EMAIL
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputDiaChi",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_ADDRESS
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputDiaChiLienHe",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_CONTACT_ADDRESS
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputIDPresenter",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_SALE_ID
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputTinhThanh",
          dataAccount?.C_PARAM_PERSONAL?.param?.C_PROVINCE
        )
      );
      if (
        dataAccount?.C_PARAM_PERSONAL?.param?.C_SALE_ID &&
        dataAccount?.C_PARAM_PERSONAL?.param?.C_SALE_ID !== "0"
      ) {
        getSaleId(dataAccount?.C_PARAM_PERSONAL?.param?.C_SALE_ID);
      }
    } else {
      dispatch(
        change("pageAccountDetailPersonal", "inputFname", ocrData?.name)
      );
      dispatch(
        change("pageAccountDetailPersonal", "inputNgaySinh", ocrData?.birthday)
      );
      dispatch(
        change("pageAccountDetailPersonal", "inputCCCD", ocrData?.cardId)
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputNgayCap",
          ocrData?.issue_date || ""
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputNoiCap",
          ocrData?.issue_by || ""
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputGioiTinh",
          ocrData?.sex ? ocrData?.sex.toUpperCase() : ""
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputDienThoai",
          dataAccount?.C_MOBILE || ""
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputEmail",
          dataAccount?.C_EMAIL || ""
        )
      );
      dispatch(
        change(
          "pageAccountDetailPersonal",
          "inputDiaChi",
          ocrData?.address || ""
        )
      );
      dispatch(change("pageAccountDetailPersonal", "inputIDPresenter", ""));
    }

    // getSaleId("1000");
  }, []);

  useEffect(() => {
    if (inputIDPresenter && !_.isEqual(inputIDPresenter, preInputIDPresenter)) {
      if (inputIDPresenter.trim().length === 4) {
        getSaleId(inputIDPresenter.trim());
      } else {
        dispatch(change("pageAccountDetailPersonal", "inputNamePresenter", ""));
      }
    }
  }, [inputIDPresenter]);

  function submit(values) {
    let isEdit = false;

    const {
      inputFname,
      inputNgaySinh,
      inputCCCD,
      inputNgayCap,
      inputNoiCap,
      inputGioiTinh,
      inputDienThoai,
      inputEmail,
      inputTinhThanh,
      inputDiaChi,
      inputDiaChiLienHe,
      inputIDPresenter,
      inputNamePresenter,
      inputAccept,
    } = values;

    if (!inputAccept) {
      _handleToast(
        "Quý khách xác nhận thông tin chính xác để tiếp tục",
        "error"
      );
      return;
    }

    const _diff = _diff2Date(new Date(), inputNgaySinh);

    if (ocrData?.loaiCmt === "cmt_9_ms") {
      if (inputCCCD.trim().length !== 9) {
        _handleToast("Hãy nhập CMT 9 số", "error");
        return;
      }

      if (!validateCMT9(inputNgayCap)) {
        _handleToast("CMT quý khách hết hạn, hãy thử lại", "error");
        return;
      }
    }
    if (ocrData?.loaiCmt && ocrData?.loaiCmt.includes("cccd")) {
      if (inputCCCD.trim().length !== 12) {
        _handleToast("Hãy nhập CCCD 12 số", "error");
        return;
      }
    }

    if (_diff / 365 < 18) {
      _handleToast("Mở tài khoản bạn phải đủ 18 tuổi", "warning");
      return;
    }

    if (!inputGioiTinh) {
      _handleToast("Chọn giới tính", "warning");
      return;
    }

    // dispatch(change("pageAccountDetailPersonal", "inputFname", ocrData?.name));
    // dispatch(change("pageAccountDetailPersonal", "inputNgaySinh", ocrData?.birthday));
    // dispatch(change("pageAccountDetailPersonal", "inputCCCD", ocrData?.cardId));
    // dispatch(change("pageAccountDetailPersonal", "inputNgayCap", ocrData?.issue_date || ""));
    // dispatch(change("pageAccountDetailPersonal", "inputNoiCap", ocrData?.issue_by || ""));
    // dispatch(change("pageAccountDetailPersonal", "inputGioiTinh", ocrData?.sex ? ocrData?.sex.toUpperCase() : ""));
    // dispatch(change("pageAccountDetailPersonal", "inputDienThoai", dataAccount?.C_MOBILE || ""));
    // dispatch(change("pageAccountDetailPersonal", "inputEmail", dataAccount?.C_EMAIL || ""));
    // dispatch(change("pageAccountDetailPersonal", "inputDiaChi", ocrData?.address || ""));

    const _province =
      ocrData?.province &&
      _.find(provinceList, (o) =>
        o.C_NAME.toLowerCase().includes(ocrData?.province.toLowerCase())
      );

    if (
      inputFname !== ocrData?.name ||
      inputNgaySinh !== ocrData?.birthday ||
      inputTinhThanh !== _province?.C_CODE ||
      inputCCCD !== ocrData?.cardId ||
      inputNgayCap !== ocrData?.issue_date ||
      inputNoiCap !== ocrData?.issue_by ||
      inputGioiTinh !== ocrData?.sex ||
      inputDiaChi !== ocrData?.address
    ) {
      isEdit = true;
    }

    const _params = {
      user: "back",
      cmd: "OPEN_INDI_ACCOUNT",
      sid: dataAccount?.S_ID,
      param: {
        C_CARD_ID: inputCCCD,
        C_FULL_NAME: inputFname,
        C_BIRTHDAY: inputNgaySinh,
        C_ISSUE_DATE: inputNgayCap,
        C_ISSUE_EXPIRE: !isDate(ocrData?.expiry)
          ? "01/01/9999"
          : ocrData?.expiry,
        C_ISSUE_PLACE: inputNoiCap,
        C_GENDER: inputGioiTinh === "NAM" ? "M" : "F",
        C_PROVINCE: inputTinhThanh,
        C_ADDRESS: inputDiaChi,
        C_CONTACT_ADDRESS: inputDiaChiLienHe,
        C_MOBILE: replaceAll(inputDienThoai, " ", ""),
        C_EMAIL: inputEmail,
        C_SALE_ID: inputNamePresenter ? inputIDPresenter : "",
        C_ANH_MAT_TRUOC: ocrData?.anhMatTruoc || "",
        C_ANH_MAT_SAU: ocrData?.anhMatSau || "",
        C_CHANNEL: "I",
        C_INFO_FLAG: isEdit ? "0" : "1", // 0 - có chỉnh sửa; 1 - ko chỉnh sửa
      },
    };

    // check account
    checkAccountCMT(_params);

    // set to store
    // let _data = Object.assign({}, dataAccount);
    // _data.C_PARAM_PERSONAL = _params;
    // dispatch(setDataAccount(_data));

    // history.push("/open-account/verify");
    // return;
  }

  function checkAccountCMT(params) {
    const url = `${apiUrl}/core`;

    const param = {
      user: "back",
      cmd: "CHECK_CARDID",
      sid: dataAccount?.S_ID,
      param: {
        C_CARD_ID: params?.param?.C_CARD_ID,
      },
    };

    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs == 1) {
          // tiếp tục mở tk
          let _data = Object.assign({}, dataAccount);
          _data.C_PARAM_PERSONAL = params;
          dispatch(setDataAccount(_data));

          history.push("/open-account/verify");
        } else {
          _handleToast("Số CMND/CCCD đã tồn tại hoặc không hợp lệ!", "error");
        }
      })
      .catch((error) => {
        _handleToast(
          "Có lỗi xảy ra trong quá trình xử lý. Vui lòng thử lại sau",
          "error"
        );
        // throw error;
      });
  }

  function getSaleId(id) {
    const url = `${apiUrl}/getSaleId`;

    const param = {
      user: "back",
      cmd: "GET_SALEID",
      sid: dataAccount?.S_ID,
      param: {
        C_SALE_ID: id,
      },
    };

    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // chưa có tài khoản
          if (json.data && !!json.data.length) {
            dispatch(
              change(
                "pageAccountDetailPersonal",
                "inputNamePresenter",
                json.data[0].SALE_NAME
              )
            );
          } else {
            _handleToast("Không tìm thấy Sale phù hợp", "warning");
          }
        } else {
          _handleToast(json.sRs, "warning");
        }
      })
      .catch((error) => {
        _handleToast(
          "Có lỗi xảy ra trong quá trình xử lý. Vui lòng thử lại sau",
          "error"
        );
        // throw error;
      });
  }

  function getProvinceList() {
    const url = `${apiUrl}/listProvince`;

    const param = {
      user: "back",
      cmd: "LIST_PROVINCE",
      sid: dataAccount?.S_ID,
      param: {},
    };

    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(param),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // chưa có tài khoản
          if (json.data && !!json.data.length) {
            setProvinceList(json.data);
            const _province =
              json.data &&
              ocrData?.province &&
              _.find(json.data, (o) =>
                o.C_NAME.toLowerCase().includes(ocrData?.province.toLowerCase())
              );
            if (_province) {
              dispatch(
                change(
                  "pageAccountDetailPersonal",
                  "inputTinhThanh",
                  _province?.C_CODE || ""
                )
              );
            }
          } else {
            setProvinceList([]);
            _handleToast("Không tìm thấy danh sách tỉnh thành", "warning");
          }
        } else {
          _handleToast(json.sRs, "warning");
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  function _handleBlurPresenter(e) {
    const { value } = e.target;
    if (value === "0") return;
    if (value && value.trim()) getSaleId(value.trim());
  }

  return (
    <Container>
      <Row>
        <Col lg="10" className="offset-lg-1">
          <div className="content pt180">
            <h2 className="mt-3">Xác thực thông tin khách hàng</h2>
            {/* <p>Quý khách vui lòng nhập thông tin dưới đây</p> */}
            <form className="account-form " onSubmit={handleSubmit(submit)}>
              <Form.Group>
                <label htmlFor="inputFname">
                  Họ và tên <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputFname"
                  type="text"
                  className="form-control"
                  placeholder="Nhập họ tên"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>
              <Form.Group>
                <label htmlFor="inputNgaySinh">
                  Ngày sinh <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNgaySinh"
                  type="text"
                  className="form-control"
                  placeholder="Nhập ngày sinh"
                  component={RenderDatePicker}
                  maxDate={new Date().getTime()}
                  validate={required}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputTinhThanh">
                  Tỉnh/Thành phố <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputTinhThanh"
                  component={RenderNormalSelect}
                  className="form-control"
                  validate={required}
                  opts={provinceList}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputCCCD">
                  Số CMND/CCCD <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputCCCD"
                  type="text"
                  className="form-control"
                  placeholder="Nhập CMND/CCCD"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputNgayCap">
                  Ngày cấp <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNgayCap"
                  type="text"
                  className="form-control"
                  placeholder="Nhập ngày cấp"
                  component={RenderDatePicker}
                  maxDate={new Date().getTime()}
                  validate={required}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputNoiCap">
                  Nơi cấp <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputNoiCap"
                  type="text"
                  className="form-control"
                  placeholder="Nhập nơi cấp"
                  component={RenderFieldNormalInput}
                  validate={required}
                />
              </Form.Group>

              <Form.Group style={{ gridColumn: "1/3" }}>
                <label htmlFor="inputDiaChi">
                  Địa chỉ thường trú <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputDiaChi"
                  className="form-control"
                  placeholder="2A Đại Cồ Việt, Hai Bà Trưng, Hà Nội"
                  component={RenderFieldNormalInput}
                  validate={[required, maxLength15]}
                />
              </Form.Group>

              <div>
                <label htmlFor="inputCardId" className="font-weight-bold">
                  Giới tính <span className="text-danger">*</span>
                </label>
                <Form.Group
                  className="check-gender"
                  style={{ alignSelf: "flex-end" }}
                >
                  <div className="custom-radio">
                    <Field
                      name="inputGioiTinh"
                      component="input"
                      type="radio"
                      value="NAM"
                      className="custom-control-input"
                      id="Gmale"
                    />
                    <label className="custom-control-label" htmlFor="Gmale">
                      Nam
                    </label>
                  </div>
                  <div className="custom-radio">
                    <Field
                      name="inputGioiTinh"
                      component="input"
                      type="radio"
                      value="NỮ"
                      className="custom-control-input"
                      id="Gfemale"
                    />

                    <label className="custom-control-label" htmlFor="Gfemale">
                      Nữ
                    </label>
                  </div>
                </Form.Group>
              </div>

              <Form.Group style={{ gridColumn: "1/3" }}>
                <label htmlFor="inputDiaChiLienHe">
                  Địa chỉ liên hệ <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputDiaChiLienHe"
                  className="form-control"
                  placeholder="Tối thiểu 15 ký tự"
                  component={RenderFieldNormalInput}
                  validate={[required, maxLength15]}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputEmail">
                  Email
                  <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputEmail"
                  type="text"
                  className="form-control"
                  placeholder="Nhập Email"
                  component={RenderFieldNormalInput}
                  validate={[required, validateEmail]}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputDienThoai">
                  Số điện thoại <span className="text-danger">*</span>
                </label>
                <Field
                  name="inputDienThoai"
                  type="text"
                  className="form-control"
                  placeholder="Nhập Số ĐT"
                  component={InputPhoneNumber}
                  validate={[required, validatePhone]}
                  disabled
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputIDPresenter">
                  ID người giới thiệu
                  <span className="text-danger">*(Nếu không có điền 0)</span>
                </label>
                <Field
                  name="inputIDPresenter"
                  type="text"
                  className="form-control"
                  placeholder="Nhập ID người giới thiệu"
                  component={RenderFieldNormalInput}
                  onBlur={_handleBlurPresenter}
                />
              </Form.Group>

              <Form.Group>
                <label htmlFor="inputNamePresenter">
                  Họ tên người giới thiệu
                </label>
                <Field
                  name="inputNamePresenter"
                  type="text"
                  className="form-control"
                  placeholder="Nhập họ tên"
                  component={RenderFieldNormalInput}
                  disabled
                />
              </Form.Group>

              <div style={{ gridColumn: "1/4" }}>
                <Form.Group
                  className="check-gender"
                  style={{ alignSelf: "flex-end" }}
                >
                  <div className="custom-radio" style={{ flex: "initial" }}>
                    <Field
                      name="inputAccept"
                      component="input"
                      type="checkbox"
                      className="custom-control-input"
                      id="inputAccept"
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="inputAccept"
                      style={{ fontWeight: "550", textTransform: "initial" }}
                    >
                      Tôi xác nhận thông tin trên là chính xác{" "}
                      <span className="text-danger">*</span>
                    </label>
                  </div>
                </Form.Group>
              </div>

              {/* <hr style={{ gridColumn: "1/4" }} /> */}

              <Row
                className="justify-content-center mt-2 mb-5"
                style={{ gridColumn: "1/4" }}
              >
                <Button onClick={() => history.goBack()} className="prev-page">
                  Quay lại
                </Button>
                <Button className="btn-next" type="submit">
                  TIẾP TỤC
                </Button>
              </Row>
            </form>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

PageAccountDetailPersonal = reduxForm({
  form: "pageAccountDetailPersonal",
  enableReinitialize: true,
})(PageAccountDetailPersonal);

const selector = formValueSelector("pageAccountDetailPersonal");

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  const {
    inputFname,
    inputNgaySinh,
    inputCCCD,
    inputNgayCap,
    inputNoiCap,
    inputGioiTinh,
    inputDienThoai,
    inputEmail,
    inputTinhThanh,
    inputDiaChi,
    inputDiaChiLienHe,
    inputIDPresenter,
    inputNamePresenter,
    inputAccept,
  } = selector(
    state,
    "inputFname",
    "inputNgaySinh",
    "inputCCCD",
    "inputNgayCap",
    "inputNoiCap",
    "inputDienThoai",
    "inputEmail",
    "inputTinhThanh",
    "inputDiaChi",
    "inputDiaChiLienHe",
    "inputIDPresenter",
    "inputNamePresenter",
    "inputAccept"
  );

  return {
    dataAccount: getDataAccount(state),
    inputFname,
    inputNgaySinh,
    inputCCCD,
    inputNgayCap,
    inputNoiCap,
    inputGioiTinh,
    inputDienThoai,
    inputEmail,
    inputTinhThanh,
    inputDiaChi,
    inputDiaChiLienHe,
    inputIDPresenter,
    inputNamePresenter,
    inputAccept,
    initialValues: {
      inputFname: "",
      inputNgaySinh: "",
      inputCCCD: "",
      inputNgayCap: "",
      inputNoiCap: "",
      inputGioiTinh: "",
      inputDienThoai: "",
      inputEmail: "",
      inputTinhThanh: "",
      inputDiaChi: "",
      inputDiaChiLienHe: "",
      inputIDPresenter: "",
      inputNamePresenter: "",
      inputAccept: true,
    },
  };
};

export default connect(mapStateToProps)(PageAccountDetailPersonal);
